/**
 * useDrift — shared React Query hook for portfolio drift (TASK-510).
 * Reuses the ['client-drift', clientId] key + retry:1 from useClientLevelData so
 * summoned tiles dedupe with each other AND with an open client dashboard.
 * retry:1 (not the default 2) because drift legitimately 404s on a missing risk profile.
 */

import { useQuery } from '@tanstack/react-query';
import { portfolioApiService } from '../services/api/portfolioApiService';

export function useDrift(clientId: string) {
  return useQuery({
    queryKey: ['client-drift', clientId],
    queryFn: () => portfolioApiService.getDrift(clientId),
    enabled: !!clientId,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
}
